import React, { useState } from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";
import entrancePhoto from "../../assets/img/ent_photo.jpg";
import { useSelector } from "react-redux";
import { translations, normalizeLang } from "../../i18n";

const Contacts = () => {
  const [showEntrancePhoto, setShowEntrancePhoto] = useState(false);
  const coords = [55.776563, 37.602373];
  const yandexMapSrc = `https://yandex.ru/map-widget/v1/?l=map&ll=${coords[1]},${coords[0]}&z=15&pt=${coords[1]},${coords[0]},pm2rdm`;

  const user = useSelector((state) => state.user.data);
  
  const lang = normalizeLang(user?.languageCode);
  const t = translations[lang];

  return (
    <div>
      <div style={{ fontSize: "12px", margin: "0 15px 15px", display: "flex" }}>
        <svg
          style={{ marginRight: "5px" }}
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.5 0C3.35775 0 0 3.3579 0 7.5C0 8.5755 0.239991 9.64665 0.703491 10.6406C0.0884912 13.8169 0.0232544 14.1094 0.0232544 14.1094C-0.0772456 14.6296 0.369741 15.0751 0.890991 14.9766C0.890991 14.9766 1.17525 14.9274 4.383 14.3204C5.35125 14.7806 6.4245 15 7.5 15C11.6422 15 15 11.6421 15 7.5C15 3.3579 11.6422 0 7.5 0ZM7.5 1.5C10.8135 1.5 13.5 4.18627 13.5 7.5C13.5 10.8137 10.8135 13.5 7.5 13.5C6.55725 13.5 5.65199 13.2786 4.82849 12.8671C4.68149 12.7939 4.52026 12.7664 4.35901 12.7969C1.69651 13.3009 1.908 13.2708 1.6875 13.3125C1.731 13.0893 1.69349 13.321 2.20349 10.6875C2.23499 10.5245 2.20725 10.3436 2.133 10.1954C1.7145 9.36608 1.5 8.4507 1.5 7.5C1.5 4.18627 4.1865 1.5 7.5 1.5ZM5.39099 3.75C4.68749 3.75 3.75 4.6875 3.75 5.39062C3.75 6.29677 4.6875 7.96875 5.625 8.90625C5.72625 9.00712 5.9925 9.27413 6.09375 9.375C7.03125 10.3125 8.70301 11.25 9.60901 11.25C10.3125 11.25 11.25 10.3125 11.25 9.60938C11.25 8.90625 10.3125 7.96875 9.60901 7.96875C9.37501 7.96875 8.52675 8.45363 8.4375 8.4375C7.6905 8.30265 6.7185 7.3071 6.5625 6.5625C6.54075 6.45855 7.03125 5.625 7.03125 5.39062C7.03125 4.6875 6.09374 3.75 5.39099 3.75Z"
            fill="black"
          />
        </svg>
        <p>{t.ContactsTitle}</p>
      </div>

      <div
        style={{
          margin: "0 15px",
          overflow: "hidden",
          borderRadius: "8px",
          backgroundColor: "#f2f2f2",
          height: "200px",
        }}
      >
        <iframe
          src={yandexMapSrc}
          width="100%"
          height="200"
          style={{ border: 0 }}
          loading="lazy"
          allowFullScreen
          title="Yandex Map"
        />
      </div>

      <div>
        <div style={{ display: "flex", gap: "10px", margin: "15px" }}>
          <div
            style={{
              flex: 1,
              borderLeft: "solid 1px #366091",
              paddingLeft: "10px",
            }}
          >
            <p style={{ fontSize: "13px" }}>{t.workingHoursTitle}</p>
            <div
              style={{ fontSize: "12px", opacity: "0.6", marginTop: "15px" }}
            >
              <p>{t.workingHoursSunThu}</p>
              <p>{t.workingHoursFriSat}</p>
              <p>{t.workingHoursHolidayNote}</p>
            </div>
          </div>
          <div
            style={{
              flex: 1,
              borderLeft: "solid 1px #366091",
              paddingLeft: "10px",
            }}
          >
            <p style={{ fontSize: "13px" }}>{t.addressTitle}</p>
            <p style={{ fontSize: "12px", opacity: "0.6", marginTop: "15px" }}>
              {t.addressLine}
              <br />
              {t.entranceHint}{" "}
              <span
                onClick={() => setShowEntrancePhoto(true)}
                style={{
                  color: "#366091",
                  cursor: "pointer",
                  fontWeight: "600",
                }}
              >
                {t.entrancePhotoLink}
              </span>
            </p>
          </div>
        </div>

        <div style={{ display: "flex", gap: "10px", margin: "15px" }}>
          <div
            style={{
              flex: 1,
              borderLeft: "solid 1px #366091",
              paddingLeft: "10px",
            }}
          >
            <p style={{ fontSize: "13px" }}>{t.residencePhonesTitle}</p>
            <div
              style={{ fontSize: "12px", opacity: "0.6", marginTop: "15px", color: "#366091", fontWeight: "600" }}
            >
              <p>
                <a href="tel:+74951915170" target="_blank" rel="noreferrer">+7 (495) 191-51-70</a>
              </p>
              <p style={{ marginTop: "5px" }}>
                <a href="tel:+79680011642" target="_blank" rel="noreferrer">+7 (968) 001-16-42</a>
              </p>
            </div>

          </div>
          <div
            style={{
              flex: 1,
              borderLeft: "solid 1px #366091",
              paddingLeft: "10px",
            }}
          >
            <p style={{ fontSize: "13px" }}>{t.ParkingTitle} (<Link to={'/parking'} style={{ color: "#366091", fontWeight: "600", opacity: "0.5" }}>{t.parkingHowToGetThere}</Link>):</p>
            <div
              style={{ fontSize: "12px", opacity: "0.6", marginTop: "15px" }}
            >
              <p>
               {t.parkingOpenBarrier}
              </p>
              <p style={{ marginTop: "5px", color: "#366091", fontWeight: "600" }}>
                <a href="tel:+74950214425" target="_blank" rel="noreferrer">+7 (495) 021-44-25</a>
              </p>
            </div>

          </div>
        </div>


        <div style={{ display: "flex", gap: "10px", margin: "15px" }}>
          <div
            style={{
              flex: 1,
              borderLeft: "solid 1px #366091",
              paddingLeft: "10px",
            }}
          >
            <p style={{ fontSize: "13px" }}>Wi-Fi:</p>
            <div
              style={{ fontSize: "12px", opacity: "0.6", marginTop: "15px" }}
            >
              <p>{t.wifiNameLabel} MusieResidence_Guest</p>
              <p>{t.wifiPasswordLabel} musieresidence</p>
            </div>
          </div>
          <div
            style={{
              flex: 1,
              borderLeft: "solid 1px #366091",
              paddingLeft: "10px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <p style={{ fontSize: "13px" }}>{t.socialNetworksTitle}</p>
            <div>
              <a
                style={{ display: "inline-flex", marginRight: "10px" }}
                href="https://www.instagram.com/musieresidence?igsh=MTlwN3hrb2RkcWNrOA=="
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  width="35"
                  height="35"
                  viewBox="0 0 35 35"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.5399 0H17.4601C7.81718 0 0 7.81717 0 17.4601V17.5399C0 27.1828 7.81718 35 17.4601 35H17.5399C27.1828 35 35 27.1828 35 17.5399V17.4601C35 7.81717 27.1828 0 17.5399 0Z"
                    fill="url(#paint0_linear_3160_7236)"
                  />
                  <path
                    d="M22.9152 7.12109H12.0852C9.09323 7.12109 6.65918 9.55514 6.65918 12.5471V22.455C6.65918 25.447 9.09323 27.881 12.0852 27.881H22.9152C25.9072 27.881 28.3412 25.447 28.3412 22.455V12.5471C28.3412 9.55514 25.9072 7.12109 22.9152 7.12109ZM8.57331 12.5471C8.57331 10.6109 10.149 9.03522 12.0852 9.03522H22.9152C24.8514 9.03522 26.4271 10.6109 26.4271 12.5471V22.455C26.4271 24.3912 24.8514 25.9669 22.9152 25.9669H12.0852C10.149 25.9669 8.57331 24.3912 8.57331 22.455V12.5471Z"
                    fill="white"
                  />
                  <path
                    d="M17.5012 22.5474C20.2835 22.5474 22.5483 20.2838 22.5483 17.5002C22.5483 14.7167 20.2847 12.4531 17.5012 12.4531C14.7177 12.4531 12.4541 14.7167 12.4541 17.5002C12.4541 20.2838 14.7177 22.5474 17.5012 22.5474ZM17.5012 14.3685C19.229 14.3685 20.6342 15.7737 20.6342 17.5015C20.6342 19.2292 19.229 20.6345 17.5012 20.6345C15.7735 20.6345 14.3682 19.2292 14.3682 17.5015C14.3682 15.7737 15.7735 14.3685 17.5012 14.3685Z"
                    fill="white"
                  />
                  <path
                    d="M23.0151 13.2666C23.7644 13.2666 24.375 12.6572 24.375 11.9068C24.375 11.1563 23.7656 10.5469 23.0151 10.5469C22.2647 10.5469 21.6553 11.1563 21.6553 11.9068C21.6553 12.6572 22.2647 13.2666 23.0151 13.2666Z"
                    fill="white"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_3160_7236"
                      x1="5.11334"
                      y1="29.8867"
                      x2="29.8867"
                      y2="5.11456"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FAAD4F" />
                      <stop offset="0.35" stop-color="#DD2A7B" />
                      <stop offset="0.62" stop-color="#9537B0" />
                      <stop offset="1" stop-color="#515BD4" />
                    </linearGradient>
                  </defs>
                </svg>
              </a>
              <a
                style={{ display: "inline-flex" }}
                href="https://vk.com/musieresidence?igsh=MTlwN3hrb2RkcWNrOA=="
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  width="35"
                  height="35"
                  viewBox="0 0 35 35"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="17.5" cy="17.5" r="17.5" fill="white" />
                  <path
                    d="M17.5 0C7.8349 0 0 7.8349 0 17.5C0 27.1651 7.8349 35 17.5 35C27.1651 35 35 27.1651 35 17.5C35 7.8349 27.1651 0 17.5 0ZM24.2302 19.744C24.2302 19.744 25.7779 21.2716 26.1589 21.9807C26.1698 21.9965 26.1765 22.0087 26.1789 22.0172C26.3332 22.276 26.3715 22.4808 26.2938 22.6315C26.1661 22.8831 25.7286 23.007 25.5792 23.018H22.8448C22.6552 23.018 22.2578 22.9687 21.7766 22.637C21.4065 22.3781 21.0419 21.9534 20.6865 21.5396C20.156 20.9234 19.6966 20.3911 19.2336 20.3911C19.1748 20.3909 19.1163 20.4001 19.0604 20.4185C18.7104 20.5315 18.262 21.031 18.262 22.3617C18.262 22.7773 17.9339 23.0161 17.7023 23.0161H16.45C16.0234 23.0161 13.8013 22.8667 11.8326 20.7904C9.42266 18.2474 7.25339 13.1469 7.23516 13.0995C7.09844 12.7695 7.38099 12.5927 7.68906 12.5927H10.4508C10.819 12.5927 10.9393 12.8169 11.0232 13.0156C11.1216 13.2471 11.4826 14.1677 12.075 15.2031C13.0357 16.8911 13.6245 17.5766 14.0966 17.5766C14.1851 17.5755 14.2721 17.553 14.35 17.5109C14.9661 17.1682 14.8513 14.9716 14.824 14.5159C14.824 14.4302 14.8221 13.5333 14.5068 13.1031C14.2807 12.7914 13.8961 12.6729 13.6628 12.6292C13.7572 12.4988 13.8816 12.3932 14.0255 12.3211C14.4484 12.1096 15.2104 12.0786 15.9669 12.0786H16.388C17.2083 12.0896 17.4198 12.1424 17.7169 12.2172C18.3185 12.3612 18.3313 12.7495 18.2784 14.0784C18.262 14.4557 18.2456 14.8823 18.2456 15.3854L18.2401 15.7354C18.2219 16.4117 18.2 17.1792 18.6776 17.4945C18.7392 17.5351 18.8117 17.5561 18.8854 17.5547C19.0513 17.5547 19.5508 17.5547 20.9034 15.2341C21.319 14.4864 21.6814 13.7103 21.988 12.9117C22.0154 12.8643 22.0956 12.7185 22.1904 12.662C22.2611 12.6284 22.3381 12.6104 22.4164 12.6091H25.663C26.0167 12.6091 26.2591 12.662 26.3047 12.7987C26.3849 13.0156 26.2901 13.6773 24.8081 15.6844L24.1464 16.5576C22.8029 18.3185 22.8029 18.4078 24.2302 19.744Z"
                    fill="#366091"
                  />
                </svg>
              </a>
            </div>
          </div>

        </div>
      </div>

      <div
        style={{ display: "flex", fontSize: "12px", margin: "30px 15px 82px" }}
      >
        <Link
          to="/send-sms"
          style={{
            backgroundColor: "#F2F2F2",
            padding: "10px",
            borderRadius: "8px",
            marginRight: "10px",
            display: "flex",
          }}
        >
          <svg
            style={{ marginRight: "5px" }}
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 0C2.6862 0 0 2.6862 0 6C0 6.7632 0.157196 7.5366 0.431397 8.2314L0.9 9.1872C1.197 9.8046 1.0926 10.3866 0.693604 11.1C0.473404 11.4948 0.7482 11.9706 1.2 11.9814C1.8102 11.9952 2.8242 11.8008 3.6 11.5128C4.3164 11.8434 5.2008 12 6 12C9.3138 12 12 9.3138 12 6C12 2.6862 9.3138 0 6 0ZM6 1.2C8.6508 1.2 10.8 3.3492 10.8 6C10.8 8.6508 8.6508 10.8 6 10.8C5.31 10.8 4.443 10.6224 3.9 10.3314C3.7392 10.245 3.5424 10.2222 3.375 10.2936C2.9922 10.4574 2.6058 10.5804 2.1564 10.6686C2.3364 10.038 2.283 9.3162 1.9686 8.6628L1.5186 7.7436C1.3188 7.2324 1.2 6.612 1.2 6C1.2 3.3492 3.3492 1.2 6 1.2ZM3.6 5.4C3.2688 5.4 3 5.6688 3 6C3 6.3312 3.2688 6.6 3.6 6.6C3.9312 6.6 4.2 6.3312 4.2 6C4.2 5.6688 3.9312 5.4 3.6 5.4ZM6 5.4C5.6688 5.4 5.4 5.6688 5.4 6C5.4 6.3312 5.6688 6.6 6 6.6C6.3312 6.6 6.6 6.3312 6.6 6C6.6 5.6688 6.3312 5.4 6 5.4ZM8.4 5.4C8.0688 5.4 7.8 5.6688 7.8 6C7.8 6.3312 8.0688 6.6 8.4 6.6C8.7312 6.6 9 6.3312 9 6C9 5.6688 8.7312 5.4 8.4 5.4Z"
              fill="#366091"
            />
          </svg>
          <p style={{ opacity: "0.85" }}>{t.writeToDirector}</p>
        </Link>
        <a
          href="https://yandex.com/maps/org/musie_residence/48054335255/?ll=37.602373%2C55.776563&z=16"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            backgroundColor: "#F2F2F2",
            padding: "10px",
            borderRadius: "8px",
            display: "flex",
          }}
        >
          <svg
            style={{ marginRight: "5PX" }}
            width="13"
            height="12"
            viewBox="0 0 13 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.575 0C1.60056 0 0 1.64124 0 3.66646C0 5.78901 1.17877 7.79156 3.12812 9.62479C3.79346 10.2501 4.50983 10.7987 5.22028 11.2914C5.4693 11.4634 5.70219 11.6194 5.91097 11.7493C6.03824 11.8287 6.12215 11.886 6.175 11.916C6.3713 12.028 6.6287 12.028 6.825 11.916C6.87784 11.886 6.96176 11.8287 7.08903 11.7493C7.29781 11.6194 7.5307 11.4634 7.77972 11.2914C8.49017 10.7987 9.20653 10.2501 9.87187 9.62479C11.8212 7.79156 13 5.78901 13 3.66646C13 1.64124 11.3994 0 9.425 0C8.30362 0 7.20876 0.62664 6.52028 1.54126C5.84896 0.610641 4.75794 0 3.575 0ZM3.575 1.33326C4.36403 1.33326 5.10087 1.74391 5.525 2.37454C5.56621 2.43587 5.89115 2.92584 5.95153 3.0205C6.20301 3.41581 6.76409 3.42782 7.02812 3.04117C7.09234 2.94718 7.43054 2.45919 7.475 2.39586C7.91771 1.76123 8.69258 1.33326 9.425 1.33326C10.6814 1.33326 11.7 2.37787 11.7 3.66646C11.7 5.33504 10.685 7.0196 8.97812 8.62485C8.36374 9.20215 7.70906 9.7288 7.04847 10.1868C6.84872 10.3254 6.67056 10.4334 6.5 10.5408C6.32944 10.4334 6.15128 10.3254 5.95153 10.1868C5.29094 9.7288 4.63625 9.20215 4.02187 8.62485C2.31498 7.0196 1.3 5.33504 1.3 3.66646C1.3 2.37787 2.31855 1.33326 3.575 1.33326Z"
              fill="#366091"
            />
          </svg>
          <p style={{ opacity: "0.85" }}>{t.leaveReviewYandex}</p>
        </a>
      </div>

      {/* Popup modal for entrance photo */}
      {showEntrancePhoto &&
        createPortal(
          <div
            onClick={() => setShowEntrancePhoto(false)}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.8)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 10000000,
              padding: "20px",
            }}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                position: "relative",
                maxWidth: "90%",
                maxHeight: "90%",
                backgroundColor: "white",
                borderRadius: "12px",
                overflow: "hidden",
              }}
            >
              <button
                onClick={() => setShowEntrancePhoto(false)}
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  width: "32px",
                  height: "32px",
                  borderRadius: "50%",
                  border: "none",
                  backgroundColor: "rgba(0, 0, 0, 0.6)",
                  color: "white",
                  fontSize: "20px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 1,
                }}
              >
                ×
              </button>
              <img
                src={entrancePhoto}
                alt="Вход в резиденцию"
                style={{
                  width: "100%",
                  height: "auto",
                  display: "block",
                  maxHeight: "80vh",
                  objectFit: "contain",
                }}
              />
            </div>
          </div>,
          document.body
        )}
    </div>
  );
};

export default Contacts;
